import React from 'react';
import {Modal} from "react-bootstrap";
import {connect} from "react-redux";
import modalManage from "../../reducers/modal-manage";

class BootstrapModal extends React.Component {
    constructor(props) {
        super(props);
        modalManage.default();
    }

    handleModalShowHide = () => modalManage.show(this.props.modalId);

    handleClose = () => modalManage.close(this.props.modalId);

    render() {
        let isShow = false;
        for (let i in this.props.modal.idsModal) {
            if (this.props.modal.idsModal[i] === this.props.modalId) {
                isShow = true;
                break;
            }
        }

        return <div>
                <Modal id={this.props.modalId}
                        className="Modal"
                        dialogClassName={this.props.dialogClassName}
                        show={isShow}
                        onHide={this.handleClose}
                        {...this.props.modalSettings}
                        centered >
                    {this.props.title &&
                        <Modal.Header closeButton onClick={this.handleClose}>
                            <Modal.Title className="Modal-Title">
                                {this.props.title}
                                </Modal.Title>
                        </Modal.Header>}
                    {this.props.children &&
                        <Modal.Body>
                            {this.props.children}
                        </Modal.Body>}
                    {this.props.btns.length > 0 &&
                        <Modal.Footer>
                            {this.props.hasOwnProperty('btns') && this.props.btns.map(el => el)}
                        </Modal.Footer>}
                </Modal>
            </div>
    }
}

const mapStateToProps = (store) => {
    return {
        modal: store.modalState,
    };
};

export default connect(mapStateToProps)(BootstrapModal);